import { launchAnalysisStream } from '../Services/stage.service';
import { launchAnalysisStreamRequest } from './stage.action';
import { getAnalysisPov, isSamePov } from '../utils/pov';

// Refusals stay outside the historical stream reducer. Its initialization and
// terminal handling begin only after the authorized analysis_context.
export const launchVersionComparisonRequest = (analysisId, selections, examinedId, options = {}) =>
    async (dispatch, getState) => {
        const original = getState();
        const viewedId = original.documentVersion.currentVersion;
        const pov = getAnalysisPov(original.stage.main_document);
        const selection = selections[0];
        if (original.stage.id !== analysisId || !viewedId || examinedId !== viewedId
            || selections.length !== 1 || selection?.reference_type !== 'document_version'
            || selection.examined_document_version_id !== viewedId
            || !selection.reference_document_version_id || selection.reference_document_version_id === viewedId
            || original.documentVersion.ia_streaming
            || (original.stage.criteriaListe || []).some(criterion => criterion.id === selection.id
                && criterion.status?.toLowerCase() === 'completed')) {
            options.onRejected?.(new Error('La comparaison doit examiner la version consultée et ne peut pas remplacer une exécution existante.'));
            return () => {};
        }
        let forwardMessage;
        let forwardError;
        let cleanup;
        let closed = false;
        let queue = Promise.resolve();
        const reject = error => {
            if (closed) return;
            closed = true;
            stream.close();
            options.onRejected?.(error);
        };
        const receive = async message => {
            if (closed) return;
            if (!forwardMessage) {
                if (message.event === 'commercial_refusal') {
                    reject(message.decision || message.data || message);
                    return;
                }
                if (['error', 'analysis_done', 'comparison_terminal'].includes(message.event) || message.type === 'error') {
                    reject(message.data || message);
                    return;
                }
                if (message.type !== 'system' || message.message !== 'analysis_context') return;
                const current = getState();
                if (message.document_version_id !== examinedId || current.stage.id !== analysisId
                    || current.documentVersion.currentVersion !== viewedId || !isSamePov(current.stage.main_document, pov)) {
                    reject(new Error('Le contexte consulté a changé. Relancez explicitement la comparaison.'));
                    return;
                }
                if (closed) return;
                cleanup = await dispatch(launchAnalysisStreamRequest(analysisId, selections, examinedId, {
                    reviewMode: 'comparison',
                    // Reuse this connection: never reserve or launch twice.
                    streamFactory: (_analysis, _criteria, _version, onMessage, onError) => {
                        forwardMessage = onMessage;
                        forwardError = onError;
                        return stream;
                    },
                }));
                options.onAccepted?.();
            }
            forwardMessage(message);
        };
        const stream = launchAnalysisStream(analysisId, selections, examinedId,
            message => { queue = queue.then(() => receive(message)).catch(reject); },
            error => { queue = queue.then(() => {
                if (closed) return;
                if (forwardError) forwardError(error);
                else reject(error);
            }).catch(reject); },
            { reviewMode: 'comparison' });
        return () => { closed = true; stream.close(); cleanup?.(); };
    };
